import { render, staticRenderFns } from "./Seasons.vue?vue&type=template&id=56053bd5&scoped=true"
import script from "@/views/Settings/Seasons/Seasons.ts?vue&type=script&lang=ts&external"
export * from "@/views/Settings/Seasons/Seasons.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Settings/Seasons/Seasons.scss?vue&type=style&index=0&id=56053bd5&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56053bd5",
  null
  
)

export default component.exports